// function clickPrev() {
//   let container = document.querySelector(
//     ".banner-carousel-section .ap-productlist__inner--scroller"
//   );

//   let btnNext = document.querySelector(".carousel-arrow-next");
//   let btnPrev = document.querySelector(".carousel-arrow-prev");

//   container.scrollTo({
//     left: container.scrollLeft - container.offsetWidth - 30,
//     top: 0,
//     behavior: "smooth",
//   });

//   if (container.offsetWidth > container.scrollLeft - container.offsetWidth) {
//     btnPrev.setAttribute("disabled", "");
//   } else {
//     btnNext.removeAttribute("disabled");
//   }
// }

// function clickNext() {
//   let container = document.querySelector(
//     ".banner-carousel-section .ap-productlist__inner--scroller"
//   );

//   let btnNext = document.querySelector(".carousel-arrow-next");
//   let btnPrev = document.querySelector(".carousel-arrow-prev");

//   let x = container.scrollLeft;
//   let y =
//     container.firstElementChild.offsetWidth * container.children.length -
//     container.offsetWidth;

//   if (x < y) {
//     container.scrollTo({
//       left: container.scrollLeft + container.offsetWidth + 30,
//       top: 0,
//       behavior: "smooth",
//     });
//     if (x + container.offsetWidth > y) {
//       btnNext.setAttribute("disabled", "");
//     } else {
//       btnPrev.removeAttribute("disabled");
//     }
//   }
// }

function rSlider(desktopColumn) {
  console.log(desktopColumn);
}
